import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const payment = {
  path: '/payments',
  component: Layout,
  name: 'payments',
  redirect: '/payments/index',
  children: [
    {
      path: '/payments/index',
      component: () => import('@/views/payment/index'),
      name: 'payments.index',
      meta: { title: i18n.t(`message.payments`)}
    },
    {
      path: '/payments/report',
      component: () => import('@/views/payment/report'),
      name: 'payments.report',
      meta: { title: i18n.t(`message.payment_report`)}
    },
  ]
}

export default payment